import React from 'react';
import { StyleSheet } from 'react-native';

import { Button } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassPurchaseCta = (props: Props) => {
  const { label, disabled, isLoading, onPress } = props;

  return (
    <Button
      size="large"
      palette="spinach"
      style={styles.container}
      aria-label={label}
      disabled={disabled}
      isLoading={isLoading}
      onPress={onPress}
    >
      {label}
    </Button>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    minHeight: 64,
  },
});

// ─── Props ───────────────────────────────────────────────────────────────────

type Props = {
  label: string;
  isLoading?: boolean;
  disabled?: boolean;
  onPress: () => void;
};
